<script lang="ts">
  import type { HeroNewsroomStoryblok } from "$types/components";
  import HeroNewsroomHeadlineOutside from "./HeroNewsroomHeadlineOutside.svelte";
  import HeroNewsroomHeadlineInside from "./HeroNewsroomHeadlineInside.svelte";

  export let blok: HeroNewsroomStoryblok;
  export let theme = "grey";
</script>

{#if blok.headlineOutside}
  <HeroNewsroomHeadlineOutside {blok} {theme} />
{:else}
  <HeroNewsroomHeadlineInside {blok} {theme} />
{/if}
